import React from "react";
import styled from "styled-components";
import Text from "./Text";

const isNotEmpty = a => !!a;

const AddressLine = styled.span`display: block;`;

const Address = ({ address, ...otherProps }) => {
  if (!address) return <Text muted>No address provided</Text>;

  const cityAndState = [address.city, address.state].filter(isNotEmpty);
  const fullAddressLine = [address.streetAddress, address.aptNumber]
    .filter(isNotEmpty)
    .join(", ");

  const locality = [
    cityAndState.length && cityAndState.join(", "),
    address.zipCode
  ]
    .filter(isNotEmpty)
    .join(" ");

  const addressArray = [fullAddressLine, locality].filter(isNotEmpty);

  // FIXME: This is going to break
  return (
    <Text {...otherProps}>
      {addressArray.map((piece, idx) => (
        <AddressLine key={idx}>{piece}</AddressLine>
      ))}
    </Text>
  );
};

export default Address;



// WEBPACK FOOTER //
// ./src/components/Address.js